import React from "react";
import { SafeArea, Image, Button, Toast } from "antd-mobile";
import styles from "./index.module.less";
import { FC, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useDocumentTitle } from "~src/hooks/useDocumentTitle";
import MaskContent from "./MaskContent";
import { getBeginList, getQuestion, getShareCheck, postGiveup, postInvitedStatus } from "~src/service/answer";
import { AnswerQuestionRef, MaskConfig, OptionType, QuestionCartType, QuestionType } from "~src/service/answer/answer";
import AnswerQuestion from "./AnswerQuestion";
import { question_backgrounk } from "~src/assets/images/answerGame";
import Toastcontent from "./Toastcontent";
import MaskShare from "~src/components/DialogContent";
import useSendCurrentPagePath from "~src/hooks/useSendCurrentPagePath";
import useQuery from "~src/hooks/useQuery";
import { useWXPath } from "~src/hooks/useWXPath";
import { useNavigate } from "react-router-dom";


const AnswerHome: FC = () => {
  const searchQuery = useQuery()
  useDocumentTitle("答题赢大奖")
  const answerid = searchQuery("answerid")
  const shareActive = searchQuery("shareActive")
  const inviter = searchQuery("inviter")
  const type: QuestionCartType = searchQuery("answerid") ? "friends" : "self"
  const { sendMessage } = useSendCurrentPagePath()
  const [maskcof, setMaskcof] = useState<MaskConfig>({} as MaskConfig)
  const [visibleShre, setVisibleShre] = useState<boolean>(false)
  const [list, setList] = useState<QuestionType[]>([])
  const questionRef = useRef<AnswerQuestionRef>(null);

  const [questionIndex, setQuestionIndex] = useState<number>(shareActive === "true" ? Number(localStorage.getItem("lv_answer_index")) : 0)
  const [footerBtnText, setFooterBtnText] = useState<string>("下一题");
  const [footerBtnDisabled, setFooterBtnDisabled] = useState<boolean>(true);
  const [answerDisabled, setAnswerDisabled] = useState<boolean>(true)
  const WaitingFreFriend = useRef<NodeJS.Timer>()
  const [timer, setTimer] = useState<number>(5)
  const wxPath = useWXPath()
  const navigate = useNavigate()
  //  朋友想要答题
  const onFriendsOpenMask = useCallback(() => {
    wxPath("redirectTo", "/pages/answer_game/index")
    setMaskcof((prev) => ({ ...prev, visible: false }))
  }, [wxPath])
  // 分享发送给view的消息
  const onSelfSendMessage = useCallback((id?: number) => {
    if (type === "self") sendMessage({
      title: "太难了！你能帮我回答下吗？5分钟内需要答案~",
      type: "share",
      path: "/answer/question",
      shareQuery: `&answerid=${id}&inviter=${localStorage.getItem("mio-id")}&share=false&type=all`,//
      selfQuery: `&share=true&type=all&answer=true&shareActive=true&index=${questionIndex}`
    })
  }, [questionIndex, sendMessage, type])
  // 打开分享弹窗
  const onOpenMaskTips = useCallback((id: number) => {
    setVisibleShre(true)
    setFooterBtnText("查看战绩")
    // setMaskcof((prev) => ({ ...prev, visible: false }))
  }, [])
  // 放弃分享
  const onWaive = useCallback(async () => {
    await postGiveup()
    setMaskcof((prev) => ({ ...prev, visible: false }))
    questionRef.current && questionRef.current.onAnswerStatus()
    setFooterBtnDisabled(false)
    setFooterBtnText("查看战绩")
  }, [])
  // 分享成功
  const AnswerResultMask: Record<QuestionCartType, (row: OptionType, id: number,assist?:number) => void> = useMemo(() => {
    const self = (row: OptionType, id: number,assist?:number) => {
      if (row.value) {
        Toast.show({
          maskClickable: false,
          content: <Toastcontent content="你真棒，答对了" value={!!row.value} />
        })
        setFooterBtnDisabled(false)
      } else {
        setMaskcof({
          visible: true,
          topIcon: "question_fail",
          title: "好可惜，答错了",
          desc: <>
            <div>好友在5分钟内帮你正确回答这道题 </div>
            <div>可继续闯关</div>
            {assist&&<div>今日还有{assist}次帮答机会</div>}
          </>,
          okText: "邀请好友帮忙答",
          onOk: onOpenMaskTips.bind(null, id),
          cancelText: "放弃",
          onCancel: onWaive
        })
      }
    }
    const friends = (row: OptionType) => {
      setMaskcof({
        visible: true,
        topIcon: row.value ? "question_success" : "question_fail",
        title: row.value ? "答对啦！助力成功" : "很遗憾~助力失败",
        desc: <>
          <div>和绿喵一起涨知识</div>
          <div>兑换惊喜礼品吧</div>
        </>,
        okText: "我也要答题",
        onOk: onFriendsOpenMask,
      })
    }
    return {
      self,
      friends
    }
  }, [onFriendsOpenMask, onOpenMaskTips, onWaive])

  // 题目超时的弹框
  const CountdowntMask: Record<QuestionCartType, () => void> = useMemo(() => {
    const self = () => {
      Toast.show({
        maskClickable: false,
        content: <Toastcontent content="很遗憾，超时了" value={false} />
      })
      setFooterBtnText("查看战绩")
      setFooterBtnDisabled(false)
      setAnswerDisabled(false)
      console.log("超时了")
    }
    const friends = () => {
      setMaskcof({
        visible: true,
        topIcon: "wait_fail",
        title: "已超时~助力失败",
        desc: <>
          <div>和绿喵一起涨知识 </div>
          <div>兑换惊喜礼品吧</div>
        </>,
        okText: "我也要答题",
        onOk: onFriendsOpenMask
      })
    }
    return {
      self,
      friends
    }
  }, [onFriendsOpenMask])
  // 分享超时的弹框
  const ShareTimedOutPopupMask: Record<QuestionCartType, () => void> = useMemo(() => {
    const self = () => {
      setMaskcof({
        visible: true,
        topIcon: "wait_fail",
        title: "闯关失败",
        desc: <>
          <div>助力时间已过，下次继续挑战</div>
        </>,
        okText: "去福利汇看看",
        onOk: () => {
          wxPath("redirectTo", "/pages/duiba_v2/mall/index")
        },
        cancelText: "返回",
        onCancel: () => {
          wxPath("redirectTo", "/pages/answer_game/index")
        }
      })
    }
    const friends = () => {
      setMaskcof({
        visible: true,
        topIcon: "wait_fail",
        title: "已超时~助力失败",
        desc: <>
          <div>和绿喵一起涨知识</div>
          <div>兑换惊喜礼品吧</div>
        </>,
        okText: "我也要答题",
        onOk: () => {
          wxPath("redirectTo", "/pages/answer_game/index")
        },
      })
    }
    return {
      self,
      friends
    }
  }, [wxPath])
  const getAnswerData = useCallback(async () => {
    if (shareActive === "true") {
      setList(JSON.parse(localStorage.getItem("lv_answerList") || "[]"))
      return
    }
    const { list=[] } = await getBeginList({ questionNum: 4 })
    localStorage.setItem("lv_answerList", JSON.stringify(list))
    setList(list || JSON.parse(localStorage.getItem("lv_answerList") || "[]"))
  }, [shareActive])
  // 被邀请人 获取答题卡数据
  const getAnswerItemData = useCallback(async () => {
    const data = await getQuestion({ questionId: answerid })
    setList([data])
  }, [answerid])
  // 放弃在邀请
  const onDiscardFriendHelp = useCallback(async () => {
    await postGiveup()
    localStorage.removeItem("lv_answer_index")
    localStorage.removeItem("lv_count_down")
    setFooterBtnText("查看战绩")
    setFooterBtnDisabled(false)
    setMaskcof((prev) => ({ ...prev, visible: false }));
  }, [])
  const onFriendHelpNext = useCallback(() => {
    setFooterBtnText(questionIndex < 3 ? "下一题" : "查看战绩")
    setFooterBtnDisabled(questionIndex < 3 ? true : false)
    setMaskcof((prev) => ({ ...prev, visible: false }));
    setQuestionIndex((prev) => questionIndex < 3 ? prev + 1 : prev)
    if (questionIndex < 3) {
      questionRef.current && questionRef.current.restartCountdown(15000)
    }
  }, [questionIndex])
  // 分享后的逻辑
  useEffect(() => {
    if (shareActive === "true") {
      const lists = JSON.parse(localStorage.getItem("lv_answerList") || "[]")
      const itemShare = lists[questionIndex]
      setTimer(Number(sessionStorage.getItem("lv_count_min") || timer))
      setAnswerDisabled(false)
      setMaskcof({
        visible: true,
        topIcon: "question_countdown",
        title: "等待好友助力",
        desc: <>
          <div>好友在5分钟内帮你正确回答这道题 </div>
          <div>可继续闯关</div>
        </>,
        okText: "多喊几个",
        onOk: onOpenMaskTips.bind(null, Number(localStorage.getItem("lv_answer_id"))),
        cancelText: "放弃",
        onCancel: onDiscardFriendHelp
      })
      const count_down = Number(localStorage.getItem("lv_count_down") || "0")
      questionRef.current && questionRef.current.setCountText(count_down)
      WaitingFreFriend.current = setInterval(async () => {
        try {
          const { status } = await postInvitedStatus({ questionId: itemShare.id })
          if (status === 1) {
            setMaskcof({
              visible: true,
              topIcon: "question_fail",
              title: "太赞啦！",
              desc: <>
                <div>好友助力成功 </div>
              </>,
              okText: "继续挑战",
              onOk: onFriendHelpNext,
            })
            clearInterval(WaitingFreFriend.current)
          }
        } catch (error) {
          clearInterval(WaitingFreFriend.current)
        }
      }, 1500)
    }
    return () => {
      clearInterval(WaitingFreFriend.current)
    }
  }, [shareActive, answerid, list])
  const getShareCheckStart = useCallback(async () => {
    const {status} = await getShareCheck({ questionId: answerid, inviter: inviter })
    const cof = {
      1: {
        title: "很遗憾~助力失败",
        icon: "question_warn"
      },
      2: {
        title: "被抢先啦~好友已获得助力",
        icon: "question_fail"
      },
      3: {
        title: "助力时间已过",
        icon: "wait_fail"
      }
    }
    if (!!status) {
      questionRef.current && questionRef.current.setCountText(15000)
      setMaskcof({
        visible: true,
        topIcon: (cof[status] as any).icon,
        title: (cof[status] as any).title,
        desc: <>
          <div>和绿喵一起涨知识</div>
          <div>兑换惊喜礼品吧</div>
        </>,
        okText: "我也要答题",
        onOk: () => {
          wxPath("redirectTo", "/pages/answer_game/index")
        },
      })
    }
 
    // if (finish) {
    //   questionRef.current && questionRef.current.setCountText(150000)
    //   setMaskcof({
    //     visible: true,
    //     topIcon: "question_fail",
    //     title: "被抢先啦~好友已获得助力",
    //     desc: <>
    //       <div>和绿喵一起涨知识</div>
    //       <div>兑换惊喜礼品吧</div>
    //     </>,
    //     okText: "我也要答题",
    //     onOk: () => {
    //       wxPath("redirectTo", "/pages/answer_game/index")
    //     },
    //   })
    // }
  }, [])
  useEffect(() => {
    if (answerid) {
      getShareCheckStart()
      getAnswerItemData()
    } else {
      getAnswerData()
    }
  }, [getAnswerData, getAnswerItemData, answerid])
  // 点击选项
  const onClickOption = async (row: OptionType, id: number, assist?:number) => {
    localStorage.setItem("lv_answer_index", JSON.stringify(questionIndex))
    localStorage.setItem("lv_answer_id", JSON.stringify(id))
    if (!row.value && assist === 0) {
      await postGiveup()
      setFooterBtnDisabled(false)
      setFooterBtnText("查看战绩")
      return
    }
    if (questionIndex === 3) {
      setFooterBtnText("查看战绩")
    }
    AnswerResultMask[type](row, id, assist)
    onSelfSendMessage(id)
  }
  // 倒计时结束
  const onCountdown = () => {
    CountdowntMask[type]()
  }
  // 下一题
  const onFooterBtn = () => {
    if (footerBtnText === "查看战绩") {
      navigate("/answer/result?share=false", { replace: true })
      return
    }
    setFooterBtnDisabled(true)
    setQuestionIndex((prev) => prev + 1)
    questionRef.current && questionRef.current.restartCountdown(15000)
  }
  const onMaskShare = () => {
    setVisibleShre(false)
  }
  const handleComplete = () => {
    clearInterval(WaitingFreFriend.current)
    ShareTimedOutPopupMask[type]()
  }

  return <div className={styles.question}>
    <div className={styles["question-back"]}>
      <Image src={question_backgrounk}></Image>
      <SafeArea position="bottom" />
    </div>
    <AnswerQuestion
      disableds={answerDisabled}
      item={list[questionIndex]}
      index={questionIndex}
      maxIndex={4}
      inviter={Number(inviter)}
      type={answerid ? "friends" : "self"}
      onCountdown={onCountdown}
      onClickOption={onClickOption}
      ref={questionRef}
    />
    {!answerid &&
      <div className={styles.footer}>
        <Button className={styles["footer-btn"]} loading={false} disabled={footerBtnDisabled} loadingText='正在加载' onClick={onFooterBtn}>{footerBtnText}</Button>
        <SafeArea position="bottom" />
      </div>
    }
    <MaskShare tips={
      <>
        <div>点击分享</div>
        <div>邀请好友助力</div>
      </>
    } visible={visibleShre} onMaskClick={onMaskShare} />
    <MaskContent
      timer={timer}
      handleComplete={handleComplete}
      title={maskcof.title}
      desc={maskcof.desc}
      okText={maskcof.okText}
      cancelText={maskcof.cancelText}
      onCancel={maskcof.onCancel}
      visible={maskcof.visible}
      onMaskClick={() => void 0}
      topIcon={maskcof.topIcon}
      onOk={maskcof.onOk}
    />
  </div>
}
export default AnswerHome